import { render, staticRenderFns } from "./AudioWaves.vue?vue&type=template&id=2f6f30ea&"
import script from "./AudioWaves.vue?vue&type=script&lang=js&"
export * from "./AudioWaves.vue?vue&type=script&lang=js&"
import style0 from "./AudioWaves.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports